import { useEffect, useState } from 'react'

import { Link } from 'react-router-dom'

import Logo from './Logo'
import LogoTitle from '../../assets/images/omar-monogram.svg'
import AnimatedLetters from '../AnimatedLetters'
import RollingText from '../RollingText'
import './index.scss'


const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const nameArray = 'mar'.split('')
  const jobArray = 'Software & AI'.split('')
  const interestArray = 'CS | Security'.split('')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i,</span>
            <br />
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>'m</span>
            <img src={LogoTitle} alt="O" />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={22}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={interestArray}
              idx={22}
            />
          </h1>
          <h2>
            Omar Abdelrazek · John Jay College · New York
          </h2>
          <Link to="/contact" className="flat-button">
            <RollingText>CONTACT ME</RollingText>
          </Link>
        </div>
        <Logo />
      </div>

    </>
  )
}

export default Home
